import { useEffect, useState } from "react";
import { GetValueSet } from "../services/terminology";

interface UseValueSetProps {
  valueSet: string;
  version?: "r4" | "r5";
  searchTerm?: string;
  debounceTime?: number;
  customUrl?: string;
  authType?: string; // Tipo de autenticação: "application" ou padrão (user token)
}

interface ValueSetOption {
  code: string;
  display: string;
  label: string;
  value: string;
}

export function useValueSet({
  valueSet,
  version,
  searchTerm = "",
  debounceTime = 500,
  customUrl,
  authType,
}: UseValueSetProps) {
  const [options, setOptions] = useState<ValueSetOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await GetValueSet({
          valueset: valueSet,
          version,
          filter: searchTerm,
          customUrl,
          authType, // Passa o tipo de autenticação
        });

        const formattedOptions =
          response?.data?.expansion?.contains?.map((item: any) => ({
            code: item.code,
            display: item.display,
            label: item.display,
            value: item.code,
          })) || [];

        setOptions(formattedOptions);
      } catch (err) {
        setError("Erro ao buscar dados");
        console.error("useValueSet error:", err);
      } finally {
        setLoading(false);
      }
    };

    const debounceTimer = setTimeout(() => {
      if (valueSet || customUrl) {
        fetchData();
      } else {
        // Sem ValueSet/URL: limpa opções (ex.: conselho sem CBO mapeado)
        setOptions([]);
      }
    }, debounceTime);

    return () => clearTimeout(debounceTimer);
  }, [valueSet, version, searchTerm, debounceTime, customUrl, authType]);

  return { options, loading, error };
}
